/**
 * Ім'я файлу з заголовка Content-Disposition: спершу `filename*` (UTF-8, кирилиця), інакше
 * ASCII-запасне `filename`; null — заголовка чи імені немає.
 */
export const contentDispositionFileName = (header: string | null): string | null => {
    if (!header) return null
    const encoded = /filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/.exec(header)?.[1]
    if (encoded) {
        try {
            return decodeURIComponent(encoded.trim())
        } catch {
            // зіпсоване кодування — беремо запасне ім'я
        }
    }
    const plain = /filename\s*=\s*("([^"]*)"|[^;]+)/.exec(header)
    const name = (plain?.[2] ?? plain?.[1])?.trim()
    return name ? name : null
}

/** Зберегти отриманий файл: тимчасове посилання з download і клік (як завантаження запиту ERP) */
export const saveBlob = (blob: Blob, fileName: string): void => {
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    // Не одразу: Safari й Firefox можуть скасувати завантаження, якщо посилання відкликано до його початку
    window.setTimeout(() => URL.revokeObjectURL(url), 10_000)
}
